import { render, staticRenderFns } from "./ProductsBoxTable.vue?vue&type=template&id=78883874&"
import script from "./ProductsBoxTable.vue?vue&type=script&lang=js&"
export * from "./ProductsBoxTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports